import React, { useEffect, useState } from "react";
import "./PaymentCard.css";
import Header from "../../Layout/Header/Header";
import Icons from "../../../../Config/Images";
import { useDispatch, useSelector } from "react-redux";
import { FaEdit, FaTrash } from "react-icons/fa"; // FontAwesome icons
import {
  upsertBankAccountApi,
  getBankAccountListApi,
} from "../../../../Store/Action/bankAction";
import { toast } from "react-toastify";
import ConfirmationPopup from "../../CustomComponents/ConfirmationPopup";
import { getAddressLists } from "../../../../Store/Action/addressAction";
import { UploadMediaRequestAPI } from "../../../../Store/Action/mediaAction";
import {
  createOrderAPI,
  getPaymentGatewayAPI,
  getPaymentMethodAPI,
  reInitiatePaymentAPI,
} from "../../../../Store/Action/orderAction";
import { clearCart } from "../../../../Store/Slice/cartSlice";
import { useLocation, useNavigate } from "react-router-dom";
import { getCartAPI } from "../../../../Store/Action/cartAction";
import { setCartItemCount } from "../../../../Store/Slice/popupTriggerSlice";
import CustomLoader from "../../CustomComponents/CustomLoader/CustomLoader";

const PaymentCard = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const {
    isDuePayment,
    orderData,
    dueAmount,
    payment_method_id,
    payment_gateway_id,
    manufacturer_id,
    orderId,
    userId,
  } = location.state || {};

  const [bankList, setBankList] = useState([]);
  const [selectedBankId, setSelectedBankId] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [bankName, setBankName] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [ifscCode, setIfscCode] = useState("");
  const [errors, setErrors] = useState({});
  const [uploadedFile, setUploadedFile] = useState(null);
  const [editingBankId, setEditingBankId] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteBankId, setDeleteBankId] = useState(null);
  const [shippingAddress, setShippingAddress] = useState([]);
  const [billingAddress, setBillingAddress] = useState({});
  const [placingOrder, setPlacingOrder] = useState(false);

  const [rtgsNumber, setRtgsNumber] = useState("");
  const [amount, setAmount] = useState("");
  const [originalDueAmount, setOriginalDueAmount] = useState(0);
  const [rtgsFileId, setRtgsFileId] = useState(null);
  const [uploading, setUploading] = useState(false);

  const [paymentMethods, setPaymentMethods] = useState([]);
  const [paymentGateway, setPaymentGateway] = useState([]);

  const rtgsMethod = paymentMethods.find(
    (m) => m.payment_method_name?.toLowerCase() === "rtgs",
  );

  const manualGateway = paymentGateway.find(
    (g) => g.payment_gateway_name?.toLowerCase() === "manual",
  );

  const liveRates = useSelector((state) => state.liveRate.rates);

  useEffect(() => {
    dispatch(
      getAddressLists({}, (result) => {
        setShippingAddress(result?.data?.shipping_address);
        setBillingAddress(result?.data?.billing_address);
      }),
    );
  }, [dispatch]);

  useEffect(() => {
    if (dueAmount) {
      const rounded = Math.ceil(Number(dueAmount));
      setAmount(rounded);
      setOriginalDueAmount(rounded);
    }
  }, [isDuePayment, dueAmount]);

  useEffect(() => {
    dispatch(
      getPaymentMethodAPI({}, (res) => {
        setPaymentMethods(res || []);
      }),
    );
  }, [dispatch]);

  useEffect(() => {
    dispatch(
      getPaymentGatewayAPI({}, (res) => {
        setPaymentGateway(res || []);
      }),
    );
  }, [dispatch]);

  const openModal = () => {
    setEditingBankId(null); // ADD mode
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setErrors({}); // clear errors
    // Optional: reset fields if you want
    setBankName("");
    setAccountNumber("");
    setIfscCode("");
    setEditingBankId(null);
  };

  const validateForm = () => {
    const newErrors = {};

    // Bank Name
    if (!bankName.trim()) {
      newErrors.bankName = "Bank name is required";
    } else if (!/^[A-Za-z ]{3,}$/.test(bankName)) {
      newErrors.bankName = "Enter a valid bank name";
    }

    // Account Number
    if (!accountNumber.trim()) {
      newErrors.accountNumber = "Account number is required";
    } else if (!/^[0-9]{9,18}$/.test(accountNumber)) {
      newErrors.accountNumber = "Account number must be 9 to 18 digits";
    }

    // IFSC
    if (!ifscCode.trim()) {
      newErrors.ifscCode = "IFSC code is required";
    } else if (!/^[A-Z]{4}0[A-Z0-9]{6}$/.test(ifscCode)) {
      newErrors.ifscCode = "Invalid IFSC code";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmitBank = () => {
    if (!validateForm()) return;

    const payload = {
      bank_name: bankName,
      account_number: accountNumber,
      ifsc_code: ifscCode,
      ...(editingBankId && { bank_account_id: editingBankId }),
    };

    dispatch(
      upsertBankAccountApi(payload, (result) => {
        if (result?.data?.status) {
          toast.success(result?.data?.message?.message);
          fetchBankList();
          closeModal();
        } else {
          toast.error(result?.data?.error?.message || "Something went wrong!");
        }
      }),
    );
  };
  useEffect(() => {
    fetchBankList();
  }, [dispatch]);

  const fetchBankList = () => {
    dispatch(
      getBankAccountListApi({}, (result) => {
        if (result?.status && result.data) {
          setBankList(result.data);
        }
      }),
    );
  };

  const handleEditBank = (bank) => {
    setEditingBankId(bank.bank_account_id);
    setBankName(bank.bank_name);
    setAccountNumber(bank.account_number);
    setIfscCode(bank.ifsc_code);
    setShowModal(true); // open modal to edit
  };

  const handleDeleteBank = (bankId) => {
    setDeleteBankId(bankId);
    setShowDeleteModal(true);
  };
  const handleConfirmDelete = () => {
    const payload = {
      bank_account_id: deleteBankId,
      flag_deleted: true,
    };

    dispatch(
      upsertBankAccountApi(payload, (result) => {
        if (result?.status) {
          toast.success(result?.data?.message?.message);
          fetchBankList();
          closeModal();
        } else {
          toast.error(result?.data?.error?.message || "Something went wrong!");
        }
      }),
    );

    fetchBankList(); // refresh list
    setShowDeleteModal(false);
    setDeleteBankId(null);
  };
  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
    setDeleteBankId(null);
  };

  const handleFileUpload = (file) => {
    if (!file) return;

    setUploading(true);

    const selectedFiles = [file];

    dispatch(
      UploadMediaRequestAPI(
        selectedFiles,
        "paymentDocument",
        false,
        (result) => {
          setUploading(false);

          if (result?.status) {
            const fileStorageId = result?.data?.[0]?.file_storage_id;
            setUploadedFile(file);
            setRtgsFileId(fileStorageId);

            toast.success("Payment proof uploaded");
          } else {
            toast.error("File upload failed");
          }
        },
      ),
    );
  };

  // When file is selected via input
  const handleFileSelect = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      handleFileUpload(file);
    }
  };

  // Handle drag over event
  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  // Handle drop event
  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const file = e.dataTransfer.files?.[0];
    if (file) {
      handleFileUpload(file);
    }
  };

  const handlePlaceOrder = () => {
    if (!selectedBankId) {
      toast.error("Please select a bank account");
      return;
    }

    // if (!rtgsNumber.trim()) {
    //   toast.error("RTGS number is required");
    //   return;
    // }

    if (!amount || Number(amount) <= 0) {
      toast.error("Please enter a valid amount");
      return;
    }

    if (!rtgsFileId) {
      toast.error("Please upload payment proof before placing the order");
      return;
    }
    setPlacingOrder(true);

    if (isDuePayment) {
      if (!rtgsMethod || !manualGateway) {
        toast.error(
          "Unable to load payment details. Please refresh the page and try again.",
        );
        setPlacingOrder(false);
        return;
      }

      const paymentPayload = {
        order_id: orderId,
        user_id: userId,
        rtgs_number: rtgsNumber,
        bank_account_id: selectedBankId,
        transaction_amount: Number(amount),
        transaction_file_storage_id: rtgsFileId,
        payment_method_id: rtgsMethod.payment_method_id,
        payment_gateway_id: manualGateway.payment_gateway_id,
      };

      dispatch(
        reInitiatePaymentAPI(paymentPayload, (result) => {
          setPlacingOrder(false);
          if (result?.status) {
            toast.success("Payment submitted successfully!");
            navigate("/my-account/my-orders");
          } else {
            toast.error("Payment failed");
          }
        }),
      );
    } else {
      if (!payment_method_id || !payment_gateway_id) {
        toast.error("Invalid payment session. Please retry.");
        navigate("/cart");
        return;
      }

      const goldRate =
        liveRates?.find((k) => k.metal?.toLowerCase() === "gold")?.rate || 0;

      const silverRate =
        liveRates?.find((k) => k.metal?.toLowerCase() === "silver")?.rate || 0;

      const payload = {
        shipping_address_id: shippingAddress?.[0]?.user_address_id,
        billing_address_id: billingAddress?.user_address_id,
        manufacturer_id: manufacturer_id,
        live_rates: {
          gold: goldRate,
          silver: silverRate,
        },
        rtgs_amount: Number(amount),
        rtgs_number: rtgsNumber,
        bank_account_id: selectedBankId,
        rtgs_receipt_file_id: rtgsFileId,
        payment_method_id,
        payment_gateway_id,
      };

      dispatch(
        createOrderAPI(payload, (result) => {
          setPlacingOrder(false);
          if (result?.data?.status) {
            toast.success(result?.data?.message?.message);
            navigate("/my-account/my-orders");
            dispatch(clearCart());
            dispatch(
              getCartAPI({}, (result) => {
                const cartLength = result?.total_count;
                dispatch(setCartItemCount(cartLength));
              }),
            );
            //   dispatch(resetWalletFlag());
          } else {
            toast.error(result?.data?.error?.message || "Order failed");
          }
        }),
      );
    }
  };

  return (
    <>
      <Header />
      <div className="payment-page">
        <div className="container-card">
          <div className="due-amount-container">
            <span className="due-label">Due Amount:</span>
            <span className="due-value">
              ₹{Number(originalDueAmount).toLocaleString()}
            </span>
          </div>
          {/* Receiver Details */}
          <div className="payment-card receiver-card">
            <div className="receiver-header">
              <div
                style={{ display: "flex", alignItems: "center", gap: "20px" }}
              >
                <div>
                  <img
                    style={{ height: "30px" }}
                    src={Icons.bank_building}
                    alt=""
                  />
                </div>
                <div style={{ textAlign: "left" }}>
                  <p className="p1">ZABALI JEWELEX PRIVATE LIMITED</p>
                  <p>Payment to this account</p>
                </div>
              </div>
              <span className="badge">RECEIVER</span>
            </div>

            <div className="receiver-info">
              <div>
                <label>Account No</label>
                <span>ZBL0973069716638</span>
              </div>
              <div>
                <label>IFSC Code</label>
                <span>INDB0000678</span>
              </div>
              <div>
                <label>CIN No</label>
                <span>U63110GJ2024PTC157383</span>
              </div>
            </div>
          </div>
          <div
            style={{
              // backgroundColor: "green",
              display: "flex",
              justifyContent: "right",

              padding: "0px 0px 10px 0px",
            }}
          >
            <div
              style={{
                display: "inline-block",
                backgroundColor: "#a8822d",
                padding: "10px 16px",
                borderRadius: "6px",
              }}
            >
              <div
                onClick={openModal}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  cursor: "pointer",
                }}
              >
                <img style={{ height: "24px" }} src={Icons.bank} alt="" />
                <span
                  style={{
                    fontFamily: `Poppins, sans-serif`,
                    fontSize: "14px",
                    color: "#ffffff",
                  }}
                >
                  Add Bank Account
                </span>
              </div>
            </div>
          </div>
          {/* Render all user bank accounts */}
          <div className="user-banks-section">
            {bankList.map((bank) => (
              <div
                key={bank.bank_account_id}
                className="payment-card receiver-card"
              >
                <div className="receiver-header">
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "20px",
                    }}
                  >
                    {/* Checkbox moved before the icon */}
                    <label className="custom-checkbox">
                      <input
                        type="checkbox"
                        checked={selectedBankId === bank.bank_account_id}
                        onChange={() => setSelectedBankId(bank.bank_account_id)}
                      />
                      <span className="checkmark"></span>
                    </label>

                    <div>
                      <img
                        style={{ height: "30px" }}
                        src={Icons.bank_building}
                        alt=""
                      />
                    </div>

                    <div style={{ textAlign: "left" }}>
                      <p className="p1">{bank.bank_name}</p>
                      <p>Payment from this account</p>
                    </div>
                  </div>

                  <span className="badge">USER BANK</span>
                </div>

                <div
                  className="receiver-info"
                  style={{ display: "flex", alignItems: "center", gap: "20px" }}
                >
                  <div>
                    <label>Account No</label>
                    <span>{bank.account_number}</span>
                  </div>
                  <div>
                    <label>IFSC Code</label>
                    <span>{bank.ifsc_code}</span>
                  </div>

                  {/* Edit/Delete icons */}
                  <div
                    style={{ marginLeft: "auto", display: "flex", gap: "10px" }}
                  >
                    <FaEdit
                      style={{ cursor: "pointer", color: "#a8822d" }}
                      onClick={() => handleEditBank(bank)}
                    />
                    <FaTrash
                      style={{ cursor: "pointer", color: "#ff4d4f" }}
                      onClick={() => handleDeleteBank(bank.bank_account_id)}
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Payment Form */}
          <div className="payment-card">
            <h3>Payment Details</h3>

            <div className="form-grid">
              {/* <input
                type="text"
                placeholder="RTGS Number"
                value={rtgsNumber}
                onChange={(e) => setRtgsNumber(e.target.value)}
              /> */}
              <input
                type="tel"
                disabled={isDuePayment}
                placeholder="Amount"
                value={amount}
                onChange={(e) => {
                  const value = e.target.value;
                  // Allow only digits and optionally a decimal point
                  if (/^\d*\.?\d*$/.test(value)) {
                    setAmount(value);
                  }
                }}
              />
            </div>

            <div className="upload-section">
              <label>Upload Payment Proof</label>

              <div
                className="upload-box"
                onDragOver={handleDragOver}
                onDrop={handleDrop}
                onClick={() => document.getElementById("fileInput").click()}
              >
                {uploading ? (
                  <span>Uploading...</span>
                ) : uploadedFile ? (
                  <span>{uploadedFile.name}</span>
                ) : (
                  <span>Click or drag file to upload</span>
                )}

                <input
                  type="file"
                  id="fileInput"
                  style={{ display: "none" }}
                  onChange={handleFileSelect}
                />
              </div>
            </div>

            <div className="action-row">
              <button
                className="primary-btn"
                onClick={handlePlaceOrder}
                disabled={placingOrder}
              >
                {placingOrder
                  ? "Processing..."
                  : isDuePayment
                    ? "Pay Due Amount"
                    : "Place Order"}
              </button>
            </div>
          </div>
        </div>
      </div>
      {showModal && (
        <div className="pay-card-modal-overlay">
          <div className="pay-card-modal-card">
            <div className="pay-card-modal-header">
              <p>Add Bank Account</p>
              <span className="pay-card-modal-close" onClick={closeModal}>
                ×
              </span>
            </div>

            <div className="pay-card-modal-body">
              <div className="pay-card-field">
                <input
                  type="text"
                  placeholder="Bank Name"
                  value={bankName}
                  onChange={(e) => setBankName(e.target.value)}
                />
                {errors.bankName && (
                  <p className="pay-card-error">{errors.bankName}</p>
                )}
              </div>

              <div className="pay-card-field">
                <input
                  type="text"
                  placeholder="Account Number"
                  value={accountNumber}
                  onChange={(e) => setAccountNumber(e.target.value)}
                />
                {errors.accountNumber && (
                  <p className="pay-card-error">{errors.accountNumber}</p>
                )}
              </div>

              <div className="pay-card-field">
                <input
                  type="text"
                  placeholder="IFSC Code"
                  value={ifscCode}
                  onChange={(e) => setIfscCode(e.target.value.toUpperCase())}
                />
                {errors.ifscCode && (
                  <p className="pay-card-error">{errors.ifscCode}</p>
                )}
              </div>
            </div>

            <div className="pay-card-modal-footer">
              <button className="pay-card-secondary-btn" onClick={closeModal}>
                Cancel
              </button>
              <button className="primary-btn" onClick={handleSubmitBank}>
                {editingBankId ? "Update Bank" : "Add Bank"}
              </button>
            </div>
          </div>
        </div>
      )}
      {showDeleteModal && (
        <div className="confirmation-modal-overlay">
          <div className="confirmation-modal-content">
            <img src={Icons.trashIcon} alt="confirmation Icon" />

            <h4 className="confirmation-modal-title">
              Are you sure you want to delete this bank account?
            </h4>

            <div className="confirmation-modal-buttons">
              <button
                onClick={handleCloseDeleteModal}
                className="confirmation-no-button"
              >
                No
              </button>

              <button
                onClick={handleConfirmDelete}
                className="confirmation-yes-button"
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      )}

      {placingOrder && (
        <div className="loaderContainer overlay-loader">
          <CustomLoader />
        </div>
      )}
    </>
  );
};

export default PaymentCard;
